export default {
      id: "calendar-usage",
      viewBox: "0 0 18 18",
      url: "/assets/" + "icons.svg#calendar",
      toString: function () {
        return this.url;
      }
    }